import { TypographyProps } from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { ResponsiveTypography } from '../ResponsiveTypography';

interface OwnProps extends TypographyProps {}

export interface SubheadingTextProps extends OwnProps {}

const SubheadingTextBase: FunctionComponent<SubheadingTextProps> = props => (
  <ResponsiveTypography
    variantMd="subheading"
    variantXs="body1"
    color="textSecondary"
    align="center"
    {...props}
  />
);

export const SubheadingText = pure(SubheadingTextBase);

SubheadingText.displayName = 'SubheadingText';
